<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-5 content">
    <div class="row mb-5">
      <div class="col-12">
        <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">Transfer of keepership</h1>
        <p class="text-center">A transfer of keepership has been requested. <br> Please review the pet details below.</p>
      </div>
    </div>
    <div class="card border-1 mb-5">
      <div class="card-top">
        <div class="card-top-image">
          <div class="card-top-image-content">
            <img src={{petImagePath}} class="card-top-image-content-img" alt="card-top-image"/>
          </div>
        </div>
        <div class="card-top-data">
          <div class="card-top-data-content">
            <div class="card-top-data-content-section">
              <div class="card-top-data-content-section-type">
                <div class="card-top-data-content-section-type-icon">
                  <img src="assets/images/tokIcons/pin.svg" alt="person" class="card-top-data-content-section-type-icon-content">
                </div>
                Pet name
              </div>
              <div class="card-top-data-content-section-data">{{petName}}</div>
            </div>
            <div class="card-top-data-content-section">      
              <div class="card-top-data-content-section-type">
                <div class="card-top-data-content-section-type-icon">
                  <img src="assets/images/tokIcons/pin.svg" alt="person" class="card-top-data-content-section-type-icon-content">
                </div>
                Date of birth
              </div>
              <div class="card-top-data-content-section-data">{{dateOfBirth}}</div>
            </div>
          </div>
          <div class="horizontal-line">
          </div>
          <div class="card-top-data-content">
            <div class="card-top-data-content-section">
              <div class="card-top-data-content-section-type">
                <div class="card-top-data-content-section-type-icon">
                  <img src="assets/images/tokIcons/pet.svg" alt="person" class="card-top-data-content-section-type-icon-content">
                </div>
                Pet type
              </div>
              <div class="card-top-data-content-section-data">
                {{petSpecies}}
              </div>
            </div>
            <div class="card-top-data-content-section">
              <div class="card-top-data-content-section-type">
                <div class="card-top-data-content-section-type-icon">
                  <img src="assets/images/tokIcons/pin.svg" alt="person" class="card-top-data-content-section-type-icon-content">
                </div>
                Implant date
              </div>
              <div class="card-top-data-content-section-data">{{implantDate}}</div>
            </div>
          </div>
          <div class="horizontal-line">
          </div>
          <div class="card-top-data-content">
            <div class="card-top-data-content-section">
              <div class="card-top-data-content-section-type">
                <div class="card-top-data-content-section-type-icon">
                  <img src="assets/images/tokIcons/breed.svg" alt="person" class="card-top-data-content-section-type-icon-content">
                </div>
                Breed
              </div>
              <div class="card-top-data-content-section-data">{{breed}}</div>
            </div>
            <div class="card-top-data-content-section">
              <div class="card-top-data-content-section-type">
                <div class="card-top-data-content-section-type-icon">
                  <img src="assets/images/tokIcons/gender.svg" alt="person" class="card-top-data-content-section-type-icon-content">
                </div>
                Sex
              </div>
              <div class="card-top-data-content-section-data">{{gender}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-bottom">
        <div class="card-bottom-chipnumber text-center">
          <div>Chip number: </div>
          <div>{{chipNumber}}</div>
        </div>
        <div *ngIf="this.showButtons" class="card-bottom-buttons">
          <button 
            type="button" 
            class="btn btn-success text-white card-bottom-buttons-body card-bottom-buttons-left" 
            [disabled]="this.alert !== null" 
            (click)="consentGivenButtonsClick(1)">
            Accept
          </button>
          <button 
            type="button" 
            class="btn btn-danger text-white card-bottom-buttons-body ml-1"
            [disabled]="this.alert !== null"
            (click)="consentGivenButtonsClick(2)">
            Refuse
          </button>
        </div>
        <div *ngIf="this.shouldShowCardBottomText" class="card-bottom-text">
          <span class="card-bottom-text-content">{{cardBottomText}}</span>
        </div>
      </div>
      <ngb-alert
        *ngIf="alert"
        [type]="alert.type"
        (closed)="closeAlert()"
        class="sticky-top"
        style="top: 10px"
        ><span [innerHTML]="alert.message"></span
      ></ngb-alert>
    </div>
  </div>
</div>
